// extracted by mini-css-extract-plugin
export var banner = "footer-module--banner--f2a01";
export var bannerLink = "footer-module--banner-link--b246e";
export var businessHours = "footer-module--business-hours--f5ae4";
export var businessHoursGroup = "footer-module--business-hours-group--90f9c";
export var contact = "footer-module--contact--96ca8";
export var contents = "footer-module--contents--ca7ea";
export var copyright = "footer-module--copyright--37395";
export var footer = "footer-module--footer--a2fe4";
export var footerInner = "footer-module--footer-inner--f0207";
export var mapInfo = "footer-module--map-info--e88a0";
export var mapLink = "footer-module--map-link--85523";
export var small = "footer-module--small--5bf46";
export var tel = "footer-module--tel--d7781";
export var toTop = "footer-module--to-top--5b572";